import { type ErrorCodeMap } from './types';

export const genieErrorCodes: ErrorCodeMap = {
  // INTEGRATION_GENIE_API_ERROR is intentionally omitted — the Rust message
  // already contains the specific error detail (e.g. "Invalid sender or password
  // supplied"). Mapping it to a generic i18n key would lose that context.
  INTEGRATION_GENIE_NOT_CONNECTED: 'desktop.errors.integration.notConnected',
  INTEGRATION_GENIE_NETWORK: 'desktop.errors.integration.connectionFailed',
  INTEGRATION_GENIE_XML_SERIALIZE: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_XML_DESERIALIZE: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_XML_PARSE: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_BASE64_DECODE: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_UTF8: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_PAYLOAD_NOT_FOUND: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_DOCUMENT_BUILD: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_PLATFORM_NOT_SUPPORTED: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_INVALID_INPUT: 'desktop.errors.integration.genie',
  INTEGRATION_GENIE_INTERNAL: 'desktop.errors.integration.genie',
};
